import { render, staticRenderFns } from "./ZipcodeModal.vue?vue&type=template&id=13134fd0"
import script from "./ZipcodeModal.vue?vue&type=script&lang=js"
export * from "./ZipcodeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports